// 重写请求拦截
//
// options 为 axios 配置
// axios的配置
// 详见 https://www.kancloud.cn/yunye/axios/234845
// interceptors 为函数，传入的 service 为 axios 实例
//
// example
//
// const IndividuationService = {
//   options: { timeout: 50 * 1000 },
//   // 拦截处理
//   interceptors(service) {
//     // 请求拦截处理
//     service.interceptors.request.use(
//       config => {
//         return config;
//       },
//       error => {
//         return Promise.reject(error);
//       }
//     );
//     // 返回拦截处理
//     service.interceptors.response.use(
//       response => {
//         return response;
//       },
//       error => {
//         return Promise.reject(error);
//       }
//     );
//   }
// };

const IndividuationService = {};

export default IndividuationService;
